module.exports = __webpack_public_path__ + "media/customizations/pomonalife/logo-00a928ef7e19441f0ec99c100e355333.png";